import { Link, useLocation } from "react-router-dom";
import { Icon } from "./icons";

// Breadcrumb derivation from the current pathname. Each segment maps
// to a human label; unknown segments fall back to the raw slug.
const SEGMENT_LABELS: Record<string, string> = {
  "": "Dashboard",
  tiendas: "Tiendas",
  proyectos: "Proyectos",
  observaciones: "Observaciones",
  archivo: "Archivo",
  consultas: "Consultas",
  avisos: "Avisos",
  analisis: "Análisis con IA",
  ia: "AI Insights",
  equipo: "Equipo",
  configuracion: "Configuración",
  "carga-unidades": "Cargar unidades",
  documentos: "Documentos",
};

type Crumb = { label: string; to: string };

// Each crumb links to the cumulative path prefix up to its segment. Every
// prefix of a Shell route (/proyectos/:id/observaciones/:obsId, /tiendas/:id,
// /proyectos/:id/archivo, …) is itself a route in App.tsx, so the links land.
export function deriveCrumbs(pathname: string): Crumb[] {
  if (pathname === "/" || pathname === "") return [{ label: "Dashboard", to: "/" }];
  const segments = pathname.split("/").filter(Boolean);
  return segments.map((seg, i) => {
    const to = "/" + segments.slice(0, i + 1).join("/");
    if (SEGMENT_LABELS[seg]) return { label: SEGMENT_LABELS[seg], to };
    // For dynamic segments (e.g. /tiendas/<id>), render a short
    // placeholder until the screen passes the resolved name via a
    // context. v1 just shows "Detalle" — the per-screen heading
    // already names the asset.
    if (i > 0) return { label: "Detalle", to };
    return { label: seg, to };
  });
}

export function Topbar({ onOpenCmdk }: { onOpenCmdk: () => void }) {
  const { pathname } = useLocation();
  const crumbs = deriveCrumbs(pathname);

  return (
    <header className="topbar">
      <nav className="topbar__crumbs">
        {crumbs.map((c, i) => (
          <span key={c.to} className="crumb-group">
            {i > 0 && <span className="crumb-sep">/</span>}
            {i === crumbs.length - 1 ? (
              <span className="crumb crumb--current" aria-current="page">
                {c.label}
              </span>
            ) : (
              <Link to={c.to} className="crumb">
                {c.label}
              </Link>
            )}
          </span>
        ))}
      </nav>

      <div className="topbar__spacer" />

      <button type="button" className="topbar__search" onClick={onOpenCmdk}>
        <Icon.Search />
        <span className="topbar__search-text">Buscar tiendas, observaciones, personas…</span>
        <span className="topbar__search-kbd">⌘K</span>
      </button>
    </header>
  );
}
